module.exports = __webpack_public_path__ + "static/media/house-2.7ba2ad81.png";